export default "__VITE_ASSET__Cicet64R__"